/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@repo/ui";
import { Trash2 } from "lucide-react";

function ContainersGrid({ data, removeRow }: any) {
  function DeleteButtonCell({ dataIndex, dataItem }: any) {
    const onClick = () => {
      removeRow(dataIndex, dataItem);
    };

    return (
      <td>
        <Button className="p-2" onClick={onClick} variant="destructive">
          <Trash2 />
        </Button>
      </td>
    );
  }

  return (
    <Grid data={data} className="my-3">
      <GridColumn field="containerType" title="Bag Type" />
      <GridColumn field="details" title="Details" />
      <GridColumn field="currency" title="Currency" width={90} />
      <GridColumn field="declaredValue" title="Value" format="{0:N2}" />
      <GridColumn field="count" width={80} title="Count" />
      <GridColumn field="sealNo" title="SealNo" />
      <GridColumn
        width={85}
        title="Remove"
        className="text-center"
        cell={DeleteButtonCell}
      />
    </Grid>
  );
}

export default React.memo(ContainersGrid);
